import React, { useEffect, useState } from "react";
import { adminAffiliates } from "../../adminApi";
import { Loader2, Users } from "lucide-react";

export default function AdminAffiliates() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => { try { setData(await adminAffiliates()); } finally { setLoading(false); } })(); }, []);

  return (
    <div>
      <h2 className="text-2xl font-extrabold text-gray-900 mb-1 flex items-center gap-2"><Users className="w-6 h-6" /> Afiliados</h2>
      <p className="text-sm text-gray-500 mb-5">Cada usuario recibe un código de referido. Quien se registre con ese código otorga 5 créditos al referente.</p>

      {loading ? (
        <p className="text-gray-500"><Loader2 className="w-5 h-5 animate-spin inline" /> Cargando...</p>
      ) : data.length === 0 ? (
        <p className="text-gray-500">No hay actividad de afiliados aún.</p>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold">Usuario</th>
                  <th className="px-4 py-3 text-left font-semibold">Código</th>
                  <th className="px-4 py-3 text-left font-semibold">Referidos</th>
                  <th className="px-4 py-3 text-left font-semibold">Créditos</th>
                </tr>
              </thead>
              <tbody>
                {data.map((a) => (
                  <tr key={a.id} className="border-t border-gray-100 hover:bg-blue-50/30">
                    <td className="px-4 py-3">
                      <div className="font-semibold text-gray-900">{a.name}</div>
                      <div className="text-xs text-gray-500">{a.email}</div>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs text-blue-700">{a.ref_code}</td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 font-bold text-xs">{a.referred_count}</span>
                    </td>
                    <td className="px-4 py-3 font-bold">{a.credits}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
